import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "review-filled",
  "use": "review-filled-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"review-filled\"><path class=\"cls-1\" d=\"M274.58 312.91L200 273.7l-74.58 39.21a6.35 6.35 0 0 1-2.82.74 6.51 6.51 0 0 1-6.52-8.11L130.23 223 69.9 164.2a6.5 6.5 0 0 1 3.6-11.09L156.88 141l37.29-75.56a6.5 6.5 0 0 1 11.66 0L243.12 141l83.38 12.12a6.5 6.5 0 0 1 3.6 11.09L269.77 223l14.24 83a6.5 6.5 0 0 1-9.43 6.85z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol